<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting">
      <a routerLink="/advanced-settings/preferences" routerLinkActive="active">Preferences</a>
      <a routerLink="/advanced-settings/tags" routerLinkActive="active">Tags</a>
      <a routerLink="/advanced-settings/Seo" routerLinkActive="active" *ngIf="validSubscription">Seo</a>
    </div>
    <div class="content__title">User Tags</div>
    <div class="content__box d-flex">
      <div class="tag m-1" *ngFor="let i of commonService.userTagList">
        {{ i }}
        <i class="fa fa-times ml-2" aria-hidden="true" (click)="ignoreTag(i)"></i>
      </div>
      <div class="tag m-1" *ngIf="commonService.userTagList.length === 0">No tags found</div>
    </div>
  </div>
</div>
